import { Message } from 'element-ui'
import axios, { urlList } from '@/xhr'
// import workflowXHR from '@/xhr/services/workflow'
import centralApi from '@/xhr/services/central'
import { uploadFiles } from '@/xhr/services/oss'

export async function startProcess(variables) {
  const form = {
    initiator: this.getUid(),
    processBusinessKey: 'process-other-house-input-v1',
    processInstanceName: '录入其他类型房源',
    processScopeId: variables.zoneId,
    variables,
  }

  const res = await centralApi.enterOtherHousing(form)
    // workflowXHR.process.newProcessInstance(form)

  if (res.data.code === 200) {
    return res.data.data
  } else {
    return Promise.reject(new Error(res.data.message))
  }
}

export async function upload(fileList) {
  try {
    const list = await uploadFiles(fileList)
    return list.map(item => item.url)
  } catch (error) {
    return []
  }
}

export async function fetchZoneOptions() {
  try {
    const res = await axios.get(
      urlList.account + `unit/treeAreaByUserOfTwo/${this.getUid()}`
    )
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    return reduceUnits(res.data.data)
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

function reduceUnits(data) {
  const map = {
    label: 'text',
    value: 'id',
  }

  const obj = deepMap({ children: data }, map)
  return obj.children
}

function deepMap(sourceObj, mapObj) {
  var obj = {}
  for (let k in mapObj) {
    if (mapObj[k]) {
      obj[k] = sourceObj[mapObj[k]]
    }
  }

  let children = sourceObj.children
  if (children && children.length) {
    obj.children = []
    for (var i = 0; i < children.length; i++) {
      var item = children[i]
      obj.children.push(deepMap(item, mapObj))
    }
  }
  return obj
}

export async function searchBlock(zoneId, keyword, houseSpaceManagerType) {
  try {
    const res = await axios.get(
      urlList.house +
        `houseSpaceManager/listBlockAndBuilding/${zoneId}/${keyword}/${houseSpaceManagerType}`
    )
    if (res.data.code !== 200) {
      return Promise.reject(res.data)
    }

    return res.data.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function validateRoomAndPrice(request) {
  // map apiX request to apiY request.

  const block = JSON.parse(request.blockName)
  const houseInfoList = JSON.parse(request.houseInfoList)
  const roomAndPrice = houseInfoList.map(item => ({
    rentalPrice: item.price,
    roomNo: item.number,
  }))
  console.log({ block })
  console.log({ roomAndPrice })
  const yReq = {
    ...block,
    houseSpaceManagerType: request.houseType,
    inputPersonnelId: this.getUid(),
    roomAndPrice,
    zoneId: request.zoneId,
  }

  try {
    const res = await axios.post(
      urlList.house + 'check/otherTypesOfHouse',
      yReq
    )
    if (res.data.code !== 200) {
      return Promise.reject(res.data)
    }

    return res.data.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/page/none/workflow/not-house-input/fetch.js